import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { MaskConfig } from '../types';

export function parseTemplate(config: MaskConfig) {
  const templateString = config.template
    ? `${config.template.entity}:${config.template.ids}`
    : null;

  const template =
    templateString !== null ? tryParseInit(templateString) : null;

  return template;
}

export function tryParseInit(rawValue: string): null | {
  entity: Entities;
  ids: number[];
  id: number;
  businessPartnerType?:
    | Entities.project
    | Entities.customer
    | Entities.supplier;
  businessPartnerId?: number;
} {
  try {
    const regex =
      /^(?<entity>.+?):(?<ids>\d+(?:,\d+)*)(:(?<bpt>customer|supplier))?(:(?<businessPartnerId>\d+))?$/;

    const result = regex.exec(rawValue);

    if (result === null) {
      return null;
    }

    const { entity, ids, bpt, businessPartnerId } = result.groups;
    if (!(entity in Entities)) {
      return null;
    }

    let businessPartnerType;
    if (bpt === 'customer') {
      businessPartnerType = Entities.customer;
    }
    if (bpt === 'supplier') {
      businessPartnerType = Entities.supplier;
    }

    const bpId = Number(businessPartnerId);

    return {
      entity: entity as Entities,
      ids: ids.split(',').map((id) => Number(id)),
      id: ids.split(',').map((id) => Number(id))[0],
      businessPartnerType: Number.isNaN(bpId) ? entity : businessPartnerType,
      businessPartnerId: Number.isNaN(bpId)
        ? Number(ids.split(',').map((id) => Number(id))[0])
        : bpId,
    };
  } catch {
    return null;
  }
}
